enum CampaignTab {
  About = "About",
  Community = "Community",
  PublicUpdates = "Public updates",
  Support = "Support",
}

export default CampaignTab;
